var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-input-wrapper"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"error"},[_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.errorText))])])],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8271db","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-input-wrapper.vue
// module id = 131
// module chunks = 0